import React from "react";

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl reveal`}>
    {eyebrow && (
      <span className={`inline-block text-xs font-semibold uppercase tracking-[0.25em] mb-3 ${light ? "text-gold" : "text-wine"}`}>{eyebrow}</span>
    )}
    <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl leading-tight ${light ? "text-cream" : "text-ink"}`}>{title}</h2>
    {subtitle && <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-cream/70" : "text-ink/60"}`}>{subtitle}</p>}
    <div className={`mt-5 ${center ? "mx-auto" : ""} w-16 h-0.5 bg-gold`} />
  </div>
);

export const PageHero = ({ title, subtitle, image }) => (
  <section className="relative h-[46vh] min-h-[340px] flex items-center justify-center overflow-hidden">
    <img src={image} alt={title || "My Own Cuvée"} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/55 to-ink/75" />
    <div className="relative z-10 text-center px-6 max-w-3xl animate-fade-up">
      <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream text-shadow-lg">{title}</h1>
      {subtitle && <p className="mt-4 text-cream/85 text-lg max-w-2xl mx-auto">{subtitle}</p>}
      <div className="mx-auto mt-6 w-20 h-0.5 bg-gold" />
    </div>
  </section>
);
